import axios from "axios";
import React from "react";

interface ILanguage {
  id: number;
  name: string;
}

export default function useLanguages(): [Map<number, string>, boolean] {
  const [languages, setLanguages] = React.useState<Map<number, string>>(
    new Map()
  );
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<ILanguage[]>("/languages/")
      .then((response) => {
        setLanguages(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, []);

  return [languages, loading];
}
